import { getAuth } from "firebase/auth";
import { LoaderFunctionArgs, useRouteError } from "react-router-dom";
import Result from "antd/es/result";
import { Button } from "antd";
import { apiClient, ContactManagementLoaderResult } from "~/services/apiClient";
import * as APITypes from "~/API";

// TODO: update this information
const BOMANI_TEAM_INFO: APITypes.User = {
  id: "bomaniTeam",
  email: "guepjopjohan@gmail.com",
  phoneNumber: "515-708-8241",
  companyName: "Bomani Team",
  __typename: "User",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const ContactManagementPageLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<ContactManagementPageLoaderType> => {
  const auth = getAuth();
  const user = auth.currentUser;

  let propertyManager: APITypes.User | null = null;
  if (user) {
    const response =
      await apiClient.loader<ContactManagementLoaderResult>(
        "contact-management",
      );
    if (response.success && response.data) {
      propertyManager = response.data.propertyManager;
    }
  }

  return {
    propertyManager,
    bomaniTeamInfo: BOMANI_TEAM_INFO,
  };
};

export type ContactManagementPageLoaderType = {
  propertyManager: APITypes.User | null;
  bomaniTeamInfo: APITypes.User;
};

export const ContactManagementPageErrorBoundary = () => {
  const error = useRouteError();
  console.error("Contact management page error", error);

  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
